import React, { useId, useState } from 'react'
import { Container, Row, Col, Card } from "react-bootstrap";
import "./ExperienceMain.css";

const ExperienceCard = ({ cargo, texto, texto2, empresa, link, textolink }) => {
    const [expanded, setExpanded] = useState(false);
    const [matrixGlyphs, setMatrixGlyphs] = useState('');
    const [revealKey, setRevealKey] = useState(0);
    const detailsId = useId();
    const bulletPoints = React.isValidElement(texto2) && texto2.type === 'ul'
        ? React.Children.toArray(texto2.props.children)
        : [];
    const firstBulletContent = bulletPoints[0]?.props?.children;
    const firstBulletText = typeof firstBulletContent === 'string' ? firstBulletContent : null;
    const previewLength = firstBulletText ? Math.floor(firstBulletText.length * 0.7) : 0;
    const isFirstBulletTruncated = firstBulletText && previewLength < firstBulletText.length;

    const showMore = () => {
        setMatrixGlyphs(Array.from({ length: 48 }, () => Math.random() < 0.5 ? '0' : '1').join(' '));
        setRevealKey((currentKey) => currentKey + 1);
        setExpanded(true);
    };

    const openInNewTab = (url) => {
        window.open(url, "_blank", "noopener,noreferrer");
    };


    return (

        <Container fluid className='py-3'>
            <Row>
                <Col>
                    <Container>

                        <Card className={`customCard${expanded ? ' is-expanded' : ''}`} style={{ width: '18rem' }}>
                            <Card.Body>
                                <Card.Title Style='color: #9F60C1;'>{cargo}</Card.Title>
                                <Card.Subtitle className="mb-2" Style='color: #6C757D;' href="#" onClick={() => openInNewTab(`${link}`)}>{empresa}</Card.Subtitle>
                                <Card.Text>
                                    {texto}
                                </Card.Text>
                                <Container>
                                    <Card.Text as="div" className='texto2'>
                                        {bulletPoints.length > 0 ? (
                                            <>
                                                {expanded && (
                                                    <span
                                                        key={revealKey}
                                                        className="experience-matrix-generation"
                                                        aria-hidden="true"
                                                    >
                                                        {matrixGlyphs}
                                                    </span>
                                                )}
                                                <ul id={detailsId} className="experience-bullet-list">
                                                    <li className="experience-bullet">
                                                        <div className="experience-bullet-inner">
                                                            <span className="experience-bullet-marker" aria-hidden="true">&#8226;</span>
                                                            <div className="experience-bullet-copy">
                                                                {isFirstBulletTruncated ? (
                                                                    <span
                                                                        className="experience-first-bullet"
                                                                        key={expanded ? 'full' : 'preview'}
                                                                    >
                                                                        {expanded
                                                                            ? firstBulletContent
                                                                            : firstBulletText.slice(0, previewLength)}
                                                                    </span>
                                                                ) : (
                                                                    <span className="experience-first-bullet">
                                                                        {firstBulletContent}
                                                                    </span>
                                                                )}
                                                                {!expanded && (isFirstBulletTruncated || bulletPoints.length > 1) && (
                                                                    <>
                                                                        {isFirstBulletTruncated && '...'}
                                                                        <button
                                                                            type="button"
                                                                            className="experience-read-more"
                                                                            aria-expanded={false}
                                                                            aria-controls={detailsId}
                                                                            onClick={showMore}
                                                                        >
                                                                            Read more
                                                                        </button>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </li>
                                                    {bulletPoints.slice(1).map((bulletPoint) => (
                                                        <li
                                                            key={bulletPoint.key}
                                                            className={`experience-extra-bullet${expanded ? ' is-visible' : ''}`}
                                                            aria-hidden={!expanded}
                                                        >
                                                            <div className="experience-bullet-inner">
                                                                <span className="experience-bullet-marker" aria-hidden="true">&#8226;</span>
                                                                <div className="experience-bullet-copy">
                                                                    {bulletPoint.props.children}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </>
                                        ) : texto2}
                                        {expanded && (bulletPoints.length > 1 || isFirstBulletTruncated) && (
                                            <button
                                                type="button"
                                                className="experience-read-more"
                                                aria-expanded={true}
                                                aria-controls={detailsId}
                                                onClick={() => setExpanded(false)}
                                            >
                                                Show less
                                            </button>
                                        )}
                                    </Card.Text>
                                </Container>
                            </Card.Body>
                        </Card>

                    </Container>

                </Col>
            </Row>
        </Container>


    )
}

export default ExperienceCard